<app-card-consulta (update)="update.emit($event)" [titulo]="titulo" [idConsulta]='idConsulta'
    [tipoConsulta]="tipoConsulta" [codigoControle]="codigoControle" [status]="status" [msg]="statusMsg">

    <ng-container *ngIf="consulta">

            <ul class="card-list-striped mb-2">
                <li>
                    <span class="text-secondary">OCORRÊNCIA MAIS ANTIGA:</span>
                    <span
                        class="text-uppercase">{{ consulta?.informacoes?.ocorrencia_mais_antiga || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">OCORRÊNCIA MAIS RECENTE:</span>
                    <span
                        class="text-uppercase">{{ consulta?.informacoes?.ocorrencia_mais_recente || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">VALOR TOTAL:</span>
                    <span class="text-uppercase">
                        <ng-container *ngIf="consulta?.informacoes?.valor_total">R$ </ng-container>
                        {{ consulta?.informacoes?.valor_total || msgNull }}
                    </span>
                </li>
            </ul>


        <ng-container *ngFor="let r of consulta?.registros; let i = index">
            <h2 class="subtitle subtitle-{{status}}">PENDÊNCIA {{i+1}}</h2>
            <ul class="card-list-striped py-1">
                <li>
                    <span class="text-secondary">DATA DA OCORRÊNCIA:</span>
                    <span class="text-uppercase">{{ r?.dataOcorrencia || r?.data_ocorrencia || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">MODALIDADE:</span>
                    <span class="text-uppercase">{{ r?.modalidade || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">VALOR:</span>
                    <span class="text-uppercase">{{ r?.valor || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">CONTRATO:</span>
                    <span class="text-uppercase">{{ r?.contrato || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">AVALISTA:</span>
                    <span class="text-uppercase">{{ r?.avalista || msgNull }}</span>
                </li>
                <li>
                    <span class="text-secondary">ORIGEM:</span>
                    <span class="text-uppercase">{{ r?.origem || msgNull }}</span>
                </li>
            </ul>
        </ng-container>

    </ng-container>

</app-card-consulta>